'use client';
import { useCartContext } from "@/providers/CartContext";
import {Link} from "@/i18n/routing";
import {useTranslations} from 'next-intl';
import {spaceAndRoundNumber} from '@/libs/number.util';

export default function HeaderCartShow({headerStyle, currency}) {
  const t = useTranslations('header.account');
  
  const { cartProducts, cartTotalPrice } = useCartContext();
  const totalProduct = cartProducts?.length;
  
  return (
    <>
      {totalProduct >= 0 ? (
        <div className={`mini-cart-icon ${headerStyle === 5 ? "mini-cart-icon-2" : ""}`}>
          <Link href="#ltn__utilize-cart-menu" className="ltn__utilize-toggle">
            <span className={headerStyle === 5 ? "mini-cart-icon" : "linkable"}>
              <i className="icon-shopping-cart"></i> <sup>{totalProduct}</sup>
            </span>
            {headerStyle === 5 ? (
              <h6>
                <span className="text-uppercase">{t('yourCart')}</span>{" "}
                <span className="ltn__secondary-color">
                  {currency?.left ? (<span className="currency-sign-font">{currency?.symbol}</span>) : ''}
                  <span>{spaceAndRoundNumber(cartTotalPrice)}</span>
                  {!currency?.left ? (<span className="currency-sign-font">{currency?.symbol}</span>) : ''}
                </span>
              </h6>
            ) : ("")}
          </Link>
        </div>
      ) : ("")}
    </>
  );
};
